import { useCallback } from 'react';
import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import {
  ClaimsTeamConfig,
  TeamPayload,
} from '@/modules/employer/components/Claims/ClaimsProcessors/ClaimsProcessors.types';

import { formatDataToPayload } from './useCreateClaimsTeam.query';

const useUpdateClaimsTeamQuery = (claimsTeamId?: string | number) => {
  const { mutateAsync, isLoading } = useMutation((value: ClaimsTeamConfig) =>
    api.put<TeamPayload>(`${API_URL.CLAIMS_TEAMS}/${claimsTeamId}`, formatDataToPayload(value))
  );

  const handleUpdate = useCallback(
    async (value: ClaimsTeamConfig) => {
      const data = await mutateAsync(value as ClaimsTeamConfig);
      const updatedTeam = data?.data;
      return updatedTeam;
    },
    [mutateAsync]
  );

  return {
    isLoading,
    update: handleUpdate,
  };
};

export default useUpdateClaimsTeamQuery;
